import { defineManifest } from "@tc/sdk";
import { MAINT_TASKS } from "./tasks.js";
export const manifest = defineManifest({
    id: "maintenance",
    name: "Maintenance",
    version: "0.1.0",
    tier: "addon",
    accent: "maintenance",
    description: "Report and track faults with photos, comments, contractor contacts and follow-ups, plus the register of equipment at every site.",
    permissions: {
        view: "See maintenance jobs and assets at your sites",
        report: "Report problems, comment, add photos, log contractor contact, propose asset changes",
        manage: "Assign, escalate, resolve and change jobs; approve asset changes",
        assets: "Add, edit, transfer and retire assets",
        admin: "Categories, category teams, alert group, category requests, bulk changes and deleting jobs",
    },
    grants: {
        "Head office": ["view", "report", "manage", "assets"],
        "Area manager": ["view", "report", "manage", "assets"],
        "Site manager": ["view", "report", "manage"],
        Supervisor: ["view", "report"],
        Staff: ["view", "report"],
    },
    tasks: MAINT_TASKS,
    widgets: [
        { key: "jobs", title: "Maintenance", description: "Open, urgent and overdue jobs at your sites, most urgent first.", group: "Jobs", size: 1, permission: "view", defaultOn: true, order: 60, live: true },
    ],
    nav: [
        { label: "Maintenance", path: "/maintenance", section: "operations", tab: "Maintenance", tabIcon: "wrench", permission: "view", icon: "wrench", order: 40, blurb: "Report faults with photos and follow them through to fixed" },
        { label: "Assets", path: "/maintenance/assets", section: "operations", tab: "Maintenance", tabIcon: "wrench", permission: "view", icon: "box", order: 41, blurb: "The register of equipment at every site" },
    ],
    setup: [
        {
            id: "response-times",
            title: "Maintenance contractors and response times",
            scope: "tenant",
            link: { label: "Open Maintenance → Contractors", path: "/maintenance/settings#contractors" },
            why: "Each contractor you use has their own agreed response times: add them under Maintenance → Settings → Contractors, and a job given a contractor takes its target date from theirs. The times below are only for jobs with no contractor (leave them blank for 1, 3, 7 and 14 days).",
            blocking: false,
            fields: [
                { key: "urgent_hours", label: "Urgent: fix within (hours)", type: "number", placeholder: "24" },
                { key: "high_days", label: "High: fix within (days)", type: "number", placeholder: "3" },
                { key: "normal_days", label: "Normal: fix within (days)", type: "number", placeholder: "7" },
                { key: "low_days", label: "Low: fix within (days)", type: "number", placeholder: "14" },
            ],
        },
    ],
});
